import PropTypes from 'prop-types';
import React from 'react';
import {Box, CircularProgress, Typography, styled} from '@mui/material';

const BottomCircle = styled(CircularProgress)(({theme}) => ({
  color: theme.palette.grey[900],
}));

const TopCircle = styled(CircularProgress)(({theme}) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  left: 0,
}));

const MajorLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.main,
  fontSize: 48,
  textAlign: 'center',
  fontWeight: 700,
}));

const MinorLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[500],
  fontSize: 16,
  textAlign: 'center',
}));

const LabelParent = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ProgressCircle = ({value, maxValue, size}) => (
  <Box position="relative">
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box position="relative">
        <BottomCircle
          variant="determinate"
          value={100}
          size={size}
          thickness={1}
        />
        <TopCircle
          variant="determinate"
          value={Math.round((value / maxValue) * 100)}
          size={size}
          thickness={1}
        />
      </Box>
    </Box>
    <LabelParent>
      <Box>
        <MajorLabel>{value}</MajorLabel>
        <MinorLabel>{`of ${maxValue}`}</MinorLabel>
      </Box>
    </LabelParent>
  </Box>
);

ProgressCircle.defaultProps = {
  size: 240,
};

ProgressCircle.propTypes = {
  value: PropTypes.number,
  maxValue: PropTypes.number,
  size: PropTypes.number,
};
